import React from "react";

import { useParams } from "react-router-dom";
import useUserProfile from "hooks/useUserProfile";
import useGuarantor from "hooks/useGuarantor";
import useEducation from "hooks/useEducation";
import { useMutation } from "react-query";
import useKycReport from "hooks/useKycReport";
import { verifyKyc } from "services/user.service";

const Education = () => {
  const params = useParams();
  const {
    data: report,
    refetch,
    isLoading: loading,
  } = useKycReport(params.id!);

  const { mutate: updateKyc, isLoading: isPending } = useMutation(
    (input: { isVerified: boolean; id: number }) =>
      verifyKyc(params.id!, input.id, input.isVerified),
    {
      onSuccess() {
        refetch();
      },
    }
  );

  const handleVerification = (value: boolean) => {
    updateKyc({ id: 3, isVerified: value });
  };

  const { data, isLoading } = useEducation(params.id!);

  if (isLoading) return <p>Loading...</p>;
  return (
    <React.Fragment>
      <div className="card" id="usersTable">
        <div className="overflow-x-auto">
          <table data-stack className="w-full">
            <thead className="ltr:text-left rtl:text-right ">
              <tr>
                <th className="px-3.5 py-2.5 font-semibold">School</th>
                <th className="px-3.5 py-2.5 font-semibold  border-custom-500 dark:border-custom-800">
                  Level
                </th>
                <th className="px-3.5 py-2.5 font-semibold  border-custom-500 dark:border-custom-800">
                  Start Date
                </th>
                <th className="px-3.5 py-2.5 font-semibold  border-custom-500 dark:border-custom-800">
                  End Date
                </th>
                <th className="px-3.5 py-2.5 font-semibold  border-custom-500 dark:border-custom-800">
                  Current School
                </th>
              </tr>
            </thead>
            <tbody className="">
              {data?.data?.length! < 1 ? (
                <div className="noresult">
                  <div className="py-6 text-center">
                    <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
                    <p className="mb-0 text-slate-500 dark:text-zink-200">
                      No Records
                    </p>
                  </div>
                </div>
              ) : (
                <>
                  {data?.data?.map?.((education) => (
                    <tr key={education._id} className=" cursor-pointer">
                      <td data-label="School" className="px-3.5 py-2.5  border-custom-500 dark:border-custom-800">
                        {education.school}
                      </td>
                      <td data-label="Level" className="px-3.5 py-2.5  border-custom-500 dark:border-custom-800">
                        {education.level}
                      </td>
                      <td data-label="Start Date" className="px-3.5 py-2.5  border-custom-500 dark:border-custom-800">
                        {education?.startDate
                          ? new Date(education?.startDate).toLocaleDateString()
                          : ""}
                      </td>
                      <td data-label="End Date" className="px-3.5 py-2.5  border-custom-500 dark:border-custom-800">
                        {education?.endDate
                          ? new Date(education?.endDate).toLocaleDateString()
                          : ""}
                      </td>
                      <td data-label="Current School" className="px-3.5 py-2.5  border-custom-500 dark:border-custom-800">
                        {education?.currentSchool ? "Yes" : "No"}
                      </td>
                    </tr>
                  ))}
                </>
              )}
            </tbody>
          </table>

          {/* {loading ? null : (
            <div className="flex items-center gap-3 m-3">
              <button
                disabled={report?.data[3]?.verified}
                onClick={() => handleVerification(true)}
                className="text-white transition-all duration-200 ease-linear btn disabled:opacity-50 bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                {report?.data[3]?.verified
                  ? "Verified"
                  : isPending
                  ? "Loading..."
                  : "Click to verify"}
              </button>
            </div>
          )} */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Education;
